<script setup lang="ts">
export type AuthGatedAction = 'ADP_BID' | 'MAKE_OFFER' | 'SDP_APPROVE' | 'SDP_DEPOT_VISIT_BOOK' | 'SDP_DOCUMENT_DOWNLOAD' | 'ADD_FAVORITE_ASSET';

interface Props {
    action?: AuthGatedAction;
}

// PROPS
const { action } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();

// DATA
const actionName = computed(() => {
    switch (action) {
        case 'ADP_BID':
        case 'MAKE_OFFER':
            return tt('login.gatedActions.makeAnOffer');
        case 'SDP_APPROVE':
            return tt('login.gatedActions.approve');
        case 'ADD_FAVORITE_ASSET':
            return tt('login.gatedActions.addToFavorites');
        case 'SDP_DEPOT_VISIT_BOOK':
            return tt('login.gatedActions.depotVisitBook');
        case 'SDP_DOCUMENT_DOWNLOAD':
            return tt('login.gatedActions.downloadDocuments');
    }
});
</script>

<template>
    <div v-if="action" class="bg-primary-500/25 ring-default flex flex-col self-stretch rounded-lg p-4 ring md:p-6">
        <p class="text-highlighted flex-1 text-sm font-semibold">{{ tt('login.gatedActions.title', { actionName: actionName }) }}</p>
    </div>
</template>
